import React from "react";
import Select, { components } from "react-select";
import SortSelectDivStyled from "./SortSelectDivStyled";

const options = [
  { value: 0, label: "Default" },
  { value: 1, label: "APY" },
  { value: 2, label: "TVL" },
];

const FarmSortSelect= ({ onChange }) => {
  const { Option } = components;

  // @ts-ignore
  const IconOption = (props) => (
    <Option key={props.data.label} className="select-option" {...props}>
      {props.data.label}
    </Option>
  );

  return (
    <SortSelectDivStyled>
      <Select
        defaultValue={options[0]}
        options={options}
        components={{ Option: IconOption }}
        onChange={onChange}
        classNamePrefix="react-select"
      />
    </SortSelectDivStyled>
  );
};

export default FarmSortSelect;
